







































































import * as Util from '@/util.ts';
import Vue from 'vue';

export default Vue.extend({
  props: {
    orderItem: {
      type: Object,
      required: true,
    },
    onClickForPayPage: {
      type: Function,
      default: (): void => undefined,
    },
    onClickForOrderPage: {
      type: Function,
      default: (): void => undefined,
    },
    tagText: {
      type: String,
    },
    showReviewControls: {
      type: Boolean,
      default: false,
    },
    showToggleButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    wasAlreadyReviewed(): boolean {
      const menuItemDocId: string = this.$props.orderItem.menuItemDocId;
      return this.$store.state.currentUserEstablishmentExchangeObject.liked.includes(menuItemDocId) || this.$store.state.currentUserEstablishmentExchangeObject.disliked.includes(menuItemDocId);
    },
  },
  methods: {
    formatOptionPrice(price: number, showSign: boolean = false): string {
      return Util.formatCurrency(price, showSign);
    },
    likedIt() {
      const newLikedArray: string[] = this.$store.state.currentUserEstablishmentExchangeObject.liked || [];
      const menuItemDocId: string = this.$props.orderItem.menuItemDocId;

      if (!newLikedArray.includes(menuItemDocId)) {
        newLikedArray.push(menuItemDocId);
      }
      const update = {
        liked: newLikedArray,
      };
      Util.updateExchangeObject(update);
    },
    dislikedIt() {
      const newDislikedArray: string[] = this.$store.state.currentUserEstablishmentExchangeObject.disliked || [];
      const menuItemDocId: string = this.$props.orderItem.menuItemDocId;

      if (!newDislikedArray.includes(menuItemDocId)) {
        newDislikedArray.push(menuItemDocId);
      }
      const update = {
        disliked: newDislikedArray,
      };
      Util.updateExchangeObject(update);
    },
  },
});
